import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { bool, func, number, string } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import classes from "./ModalFooter.module.scss";

const ModalFooter = ({
  isNextDisabled = false,
  nextButtonText = "Next",
  onClickNext,
  stepNumber = 1,
}) => {
  const dispatch = useDispatch();

  const onClickCancel = (e) => {
    e?.preventDefault();
    dispatch(hideModal(modalTypes.START_WRITING_PROPOSAL_OUTLINE_WIZARD));
  };

  return (
    <Modal.Footer>
      <span className={classes.step}>Step {stepNumber}</span>

      <NewButton
        data-testid="btn-cancel-wizard"
        variant={NewButtonVariant.l2}
        onClick={onClickCancel}
      >
        Cancel
      </NewButton>

      <NewButton
        data-testid="btn-next-step"
        disabled={isNextDisabled}
        variant={NewButtonVariant.l1}
        onClick={onClickNext}
      >
        {nextButtonText}
      </NewButton>
    </Modal.Footer>
  );
};

ModalFooter.propTypes = {
  isNextDisabled: bool,
  nextButtonText: string,
  onClickNext: func,
  stepNumber: number,
};

export default ModalFooter;
